module.exports = __webpack_public_path__ + "img/web.043f3ed.svg";